module.exports = __webpack_public_path__ + "img/mobile-mapping-intro.f370e92c.jpg";